import { UniversalLink } from '@plone/volto/components';
import { forwardRef, PropsWithChildren } from 'react';

import { filterObject } from '@designsystem/stories/01-core/Utilities';

export interface LinkProps
  extends PropsWithChildren,
    React.ComponentPropsWithRef<any> {
  /** Link */
  href?: string;
  /** Title on link */
  title?: string;
  /** Link target */
  target?: HTMLAnchorElement['target'];
  /** Additional class */
  className?: string;
}

/** A link */
export const Link = forwardRef(
  ({ children, ...props }: LinkProps, ref?: any) => {
    if (!props?.target) {
      if (
        props?.href?.endsWith('@@display-file/file') ||
        (props?.href?.endsWith('.pdf') && props?.href.startsWith('http'))
      ) {
        props.target = '_blank';
        props.rel = 'noopener noreferrer';
      }
    }

    if (!props?.role && props?.href) {
      props.role = 'link';
    }

    const allowedProps = [
      'href',
      'title',
      'className',
      'target',
      'rel',
      'role',
    ];
    const filteredProps = filterObject(
      props,
      allowedProps,
      [],
      /(aria|data)-.*/,
    );

    return (
      <UniversalLink ref={ref} {...(filteredProps as any)}>
        {children}
      </UniversalLink>
    );
  },
);
